import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import { ACCOUNT_ADVANCED_SALARY_ROUTE, ACCOUNT_DASHBOARD, ACCOUNT_DEALS_ROUTE, ACCOUNT_EXPENSES_ROUTE, AGENTS_ROUTE, CONTACTS_ROUTE, INTEGRATION_HUB, LEADS_ROUTE, LIVE_TRACKING, PACKAGES, PROPERTIES_ROUTE, REPORTS, ROLES_ROUTE, TASKS_ROUTE, VENDOR, XML_FEED } from "../../../constants/routes";
import { MdOutlinePictureAsPdf, MdOutlineContactPhone, MdRealEstateAgent, MdOutlineLeaderboard, MdPayment, MdAddToPhotos  } from "react-icons/md";
import { FaDollarSign, FaTasks } from "react-icons/fa";
import { FaPeopleRoof, FaSquarePollVertical } from "react-icons/fa6";
import { SiOnlyoffice } from "react-icons/si";
import { LuPackage2 } from "react-icons/lu";
import { IoMdSettings } from "react-icons/io";
import { IoLocation } from "react-icons/io5";
import { SiHubspot } from "react-icons/si";

export const LINKS = [
  {
    title: "Dashboard",
    icon: DashboardOutlinedIcon,
    href: "/",
  },
  {
    title: "Properties",
    icon: MdRealEstateAgent,
    href: PROPERTIES_ROUTE,
  },

  {
    title: "HR Management",
    icon: FaPeopleRoof,
    href: AGENTS_ROUTE,
  },

  // {
  //   title: "Add Staff",
  //   icon: IoPersonAddSharp,
  //   href: ADD_AGENT_ROUTE,
  // },
  {
    title: "Tasks",
    icon: FaTasks,
    href: TASKS_ROUTE,
  },
  {
    title: "Leads",
    icon: MdOutlineLeaderboard ,
    href: LEADS_ROUTE,
  },
  {
    title: "Contacts",
    icon: MdOutlineContactPhone ,
    href: CONTACTS_ROUTE,
  },
   {
    title: "Live Tracking",
    icon: IoLocation ,
    href: LIVE_TRACKING,
  },
 {
    title: "Accounts",
    icon: SiOnlyoffice ,
    href: ACCOUNT_DASHBOARD,
  },
 {
    title: "Settings",
    icon: IoMdSettings ,
    href: ROLES_ROUTE,
  },
//  {
//     title: "XMl Feed",
//     icon: LuCodeXml ,
//     href: XML_FEED,
//   },
 {
    title: "Integrations Hub",
    icon: SiHubspot,
    href: INTEGRATION_HUB,
  },


];
export const ACCOUNTS_OPTIONS = [
  //  {
  //   title: "Dashboard",
  //   icon: MdOutlineSpaceDashboard,
  //   href: ACCOUNT_DASHBOARD,
  // },
  //   {
  //   title: "Salary Statements",
  //   icon: BsFileSpreadsheet,
  //   href: SALARY_DASHBOARD,
  // },
  {
    title: "Deals",
    icon: MdOutlinePictureAsPdf,
    href: ACCOUNT_DEALS_ROUTE,
  },
    {
    title: "Expenses",
    icon: FaDollarSign,
    href: ACCOUNT_EXPENSES_ROUTE,
  },
  //  {
  //   title: "Payroll",
  //   icon: MdOutlinePayments,
  //   href: ACCOUNT_PAYROLL_ROUTE,
  // },
   {
    title: "Advanced Salary",
    icon: MdPayment,
    href: ACCOUNT_ADVANCED_SALARY_ROUTE,
  },
    {
    title: "Add Vendor",
    icon: MdAddToPhotos ,
    href: VENDOR,
  },
   {
    title: "Reports",
    icon: FaSquarePollVertical ,
    href: REPORTS,
  },
  {
    title: "Purchase Packages",
    icon: LuPackage2,
    href: PACKAGES ,
  },
  //  {
  //   title: "Attendance",
  //   icon: FaStamp,
  //   href: ATTENDANCE ,
  // },
];